<!--
 * @Autor: yingna.gao
 * @Date: 2022-12-22 11:40:48
 * @LastEditTime: 2022-12-23 10:13:13
 * @LastEditors: yingna.gao
 * @Description:
 * @FilePath: /common-web/src/views/standard/report-config/inner-components/batch-table-add.vue
-->
<template>
  <el-dialog
    :key="formKey"
    v-dialogDrag
    title="批量添加"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    custom-class="self-dialog-form"
    width="800px"
  >
    <el-form
      ref="formRef"
      label-position="top"
      :model="formData"
    >
      <el-input
        style="padding-bottom:8px"
        class="example"
        size="mini"
        value='示例：[{"columnTitle":"名称","columnName":"name"},{"columnTitle":"编码","columnName":"code"}]'
      ></el-input>
      <el-form-item>
        <el-input
          v-model="formData.batchData"
          type="textarea"
          :autosize="{ minRows: 6, maxRows: 6 }"
          :placeholder="$t('public.pleaseEnter')"
        >
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button plain @click="dialogVisible = false">{{ $t("public.cancel") }}</el-button>
      <el-button type="primary"  @click="handleConfirm">
        {{ $t("public.confirm") }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "BatchTableAdd",
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formKey: new Date().getTime(),
      formData: {
        batchData: ""
      },
      formRules: {
      },
      typeOptions: [],
      loading: false
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    }
  },
  created() {
  },
  methods: {
    trimLR(val) {
      return val.replace(/^\s+|\s+$/gm, "");
    },
    // 确认提交
    handleConfirm() {
      if (this.formData.batchData) {
        const tableList = JSON.parse(this.formData.batchData);
        if (Object.prototype.toString.call(tableList) === "[object Array]") {
          const pass = tableList.some(item => !Object.keys(item).includes("columnTitle") || !Object.keys(item).includes("columnName"));
          if (pass) {
            this.$message.error("输入的数据columnTitle和columnName不对");
          } else {
            this.$emit("refresh", tableList);
            this.dialogVisible = false;
          }
        } else {
          this.$message.error("请填写正确格式的数据");
        }
      } else {
        this.$emit("refresh", []);
        this.dialogVisible = false;
      }
    }
  }
};
</script>

<style scoped lang="scss">
  .example{
    ::v-deep input{
      border: 0;
      background-color: #f9f9f9;
      color:#999;
    }
  }
</style>
